exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-container ul.tabs li.active>a[data-v-2175f09d],.tab-container ul.tabs li:hover>a[data-v-2175f09d]{color:#fdb714}.icon-check4[data-v-2175f09d]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check4[data-v-2175f09d]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #fdb714}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2175f09d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rebooking/pagecontent/BookingnoBookingDetails.vue
// module id = 508
// module chunks = 0